// Shared design tokens and small presentation helpers for the SimpliGPS Go
// web UI. Mirrored from the mobile app's app_design.dart so web and app look
// and behave the same (same spacing, radii, status colors, avatar colors and
// initials). Keep the values in sync with the mobile app.

export const spacing = {xs: 4, sm: 8, md: 12, lg: 16, xl: 24, xxl: 32};

export const radii = {sm: 10, md: 16, lg: 22, pill: 999};

// Semantic status colors (theme independent).
export const statusColors = {
    live: "#22C55E",    // online and recent
    moving: "#3B82F6",  // in motion
    warn: "#F59E0B",    // stale or low battery
    offline: "#9CA3AF", // no recent fix
    danger: "#EF4444",  // sos or critical
};

const avatarPalette = [
    "#6B46C1", "#EC4899", "#0EA5E9", "#10B981",
    "#F59E0B", "#EF4444", "#8B5CF6", "#14B8A6",
];

// Deterministic accent color so the same name always gets the same color.
// Same palette and hash as the mobile app.
export function avatarColor(seed) {
    const s = seed || "";
    let hash = 0;
    for (let i = 0; i < s.length; i++) {
        hash = (hash * 31 + s.charCodeAt(i)) & 0x7fffffff;
    }
    return avatarPalette[hash % avatarPalette.length];
}

// First + last initials. "Mom" -> "M", "Dad's Truck" -> "DT", "" -> "?".
export function initials(name) {
    const parts = (name || "").trim().split(/\s+/).filter((p) => p.length);
    if (!parts.length) return "?";
    if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
    return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
}

// Compact relative time: "now", "3m", "2h", "5d", "2w".
export function relativeTime(date) {
    if (!date) return "-";
    const d = date instanceof Date ? date : new Date(date);
    if (Number.isNaN(d.getTime())) return "-";
    const diffSec = Math.floor((Date.now() - d.getTime()) / 1000);
    if (diffSec < 45) return "now";
    const min = Math.floor(diffSec / 60);
    if (min < 60) return `${min}m`;
    const hr = Math.floor(min / 60);
    if (hr < 24) return `${hr}h`;
    const day = Math.floor(hr / 24);
    if (day < 7) return `${day}d`;
    return `${Math.floor(day / 7)}w`;
}
